import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import SupplierList from './supplier-list';
import PendingSupplierList from './pending-supplier-list';
import clsx from 'clsx';

const SupplierManagement = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('SupplierList')
  
  return (

    <div className='card card-custom'>
      <div className='card-header card-header-stretch overflow-auto'>
        <ul
          className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
          role='tablist'
        >
          <li className='nav-item'>
            <a
              className={clsx(`nav-link cursor-pointer`, { active: tab === 'SupplierList' })}
              onClick={() => setTab('SupplierList')}
              role='tab'
            >
              {t("supplier_list")}
            </a>
          </li>
          <li className='nav-item'>
            <a
              className={clsx(`nav-link cursor-pointer`, { active: tab === 'PendingSupplierList' })}
              onClick={() => setTab('PendingSupplierList')}
              role='tab'
            >
              {t("pending_supplier_list")}
            </a>
          </li>
        </ul>
      </div>
      <div className='tab-content pt-3'>
        <div className={clsx('tab-pane', { active: tab === 'SupplierList' })}>

          <SupplierList></SupplierList>

        </div>
        <div className={clsx('tab-pane', { active: tab === 'PendingSupplierList' })}>

          <PendingSupplierList></PendingSupplierList>

        </div>
      </div>
    </div>


  )
}
export default SupplierManagement